import React from 'react'; 
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import BackgroundMusic from './components/BackgroundMusic';
import BackgroundVideo from './components/BackgroundVideo';
import LanguageSwitcher from './components/LanguageSwitcher';
import Popup from './components/Popup'; 
import './i18n'; 


const App = () => {
  return (
    <Router>
      <div>
        <Popup />
        <Navbar />
        <BackgroundVideo />
        <LanguageSwitcher />
        <BackgroundMusic />
        <div className="content-container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/events" element={<Events />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
